




















































































import { Component, Prop, Vue, Provide, Watch } from "vue-property-decorator";
import { ReportResult, TOTAL_KEY } from "@/app-data/report/entities/reportEntity";
import { API_BIS_PATENT_LIST } from "@/configs/Apis";
import { MONITOR_PROJECT_ID } from "@/app-data/monitor/monitor";
import DEmpty from "../base/DEmpty.vue";
import colFormatters from "@/utils/ColumnFormater";
import { isEmptyOrWhiteSpace } from "@/utils/Common";

import FileSaver from "file-saver";
import XLSX from "xlsx/xlsx.mini";

declare interface Cell {
  content: string
  colspan: number
  rowspan: number
  rowstart: boolean
  rowend: boolean
}

declare interface Row {
  cells: Array<Cell>
}

declare interface Table {
  rows: Array<Row>
}

@Component({ components: { DEmpty } })
export default class ReportTable extends Vue {
  @Prop({ type: Object, required: true })
  reportDefine!: any;

  @Prop({ type: Object, required: true })
  reportData!: ReportResult;

  @Prop({ type: String, required: false })
  reportTitle!: string;

  @Prop({ type: Boolean, required: false })
  hideMeasureLink!: boolean;

  showReportListWin = false;
  reportWinTitle = "专利列表";
  patentData: Array<any> = [];
  condition: any = {}
  pageSize = 20;
  pageIndex = 1;
  recordCount = 0;

  get rowDims() {
    return this.reportDefine.rowDims || [];
  }

  get colDims() {
    return this.reportDefine.colDims || [];
  }

  get patentColumns() {
    const columns: Array<any> = [{ prop: "patentNo", label: "申请号", hidden: false },
      { prop: "patentType", label: "专利类型", hidden: false },
      { prop: "title", label: "专利名称", hidden: false },
      // { prop: "modifiedTime", label: "导入时间", hidden: false },
      { prop: "appDate", label: "申请日", hidden: false },
      { prop: "pubNo", label: "公开(公告)号", hidden: false },
      { prop: "pubDate", label: "公开(公告)日", hidden: false },
      { prop: "authDate", label: "授权日", hidden: false },
      { prop: "country", label: "专利所属国", hidden: false },
      { prop: "patentee", label: "当前专利权人", hidden: false },
      { prop: "applicants", label: "申请人", hidden: false, width: 180 },
      { prop: "primaryApplicantName", label: "主申请人", hidden: false, width: 180 },
      { prop: "applicantCountry", label: "申请人(国家)", hidden: false },
      { prop: "applicantProvince", label: "申请人(省)", hidden: false },
      { prop: "applicantCity", label: "申请人(市)", hidden: false },
      { prop: "applicantArea", label: "申请人(区县)", hidden: false },
      { prop: "applicantAddress", label: "申请人地址", hidden: false },
      { prop: "inventors", label: "发明人", hidden: false },
      { prop: "primaryInventorName", label: "主发明人", hidden: false, width: 180 },
      { prop: "agencyName", label: "代理机构", hidden: false },
      { prop: "agentName", label: "代理人", hidden: false },
      { prop: "priorityPatents", label: "优先权", hidden: false },
      { prop: "inteAppDate", label: "国际申请日", hidden: false },
      { prop: "inteAppNo", label: "国际申请号", hidden: false },
      { prop: "intePubDate", label: "国际公布日", hidden: false },
      { prop: "intePubNo", label: "国际公布号", hidden: false },
      { prop: "legalStatus", label: "法律状态", hidden: false },
      { prop: "primaryIpc", label: "IPC主分类", hidden: false },
      { prop: "miniIpc", label: "IPC小类", hidden: false },
      { prop: "shortIpc", label: "IPC大类", hidden: false },
      { prop: "ipc", label: "IPC", hidden: false },
      { prop: "cpc", label: "CPC", hidden: false },
      { prop: "ecla", label: "ECLA", hidden: false }];
    // columns.filter(col => col.prop === "patentNo").forEach(col => col.clickable = true);
    return columns;
  }

  getFormatters(prop: string) {
    if (isEmptyOrWhiteSpace(prop)) {
      return null;
    }
    const chars = prop.split("");
    chars[0] = chars[0].toUpperCase();
    const formatKey = `format${chars.join("")}`;
    return colFormatters[formatKey] || function (data: any, column: any, value: any) {
      return value;
    };
  }

  emptyCell(): Cell {
    return { colspan: 0, content: "", rowend: false, rowspan: 0, rowstart: false };
  }

  get top() {
    if (!this.reportData.dataValues ||
      this.reportData.dataValues.length == 0 ||
      this.reportData.rowCount == 0) {
      return { rows: [] };
    }

    const msrlength = this.reportDefine.measures.length;
    const cdimlength = this.reportDefine.colDims ? this.reportDefine.colDims.length : 0;

    const headeritem = [];
    if (cdimlength > 0) {
      for (var k = 0; k < cdimlength; k++) {
        for (var i = 0; i < this.reportData.colDimNodes.length; i++) {
          if (!this.reportData.colDimNodes[i][k]) {
            continue;
          }

          if (i == 0 ||
            !this.reportData.colDimNodes[i - 1][k] ||
            this.reportData.colDimNodes[i][k].value != this.reportData.colDimNodes[i - 1][k].value) {
            const item: Cell = this.emptyCell();
            item.content = this.getColDimContent(i, k);

            let cspan = i + 1;
            while (this.reportData.colDimNodes[cspan] &&
            this.reportData.colDimNodes[cspan][k] &&
            this.reportData.colDimNodes[i][k].value == this.reportData.colDimNodes[cspan][k].value &&
            !this.reportData.colDimNodes[cspan][k].total) {
              cspan++;
            }

            item.colspan = (cspan - i) * msrlength;

            item.rowspan = 1;
            if (this.reportData.colDimNodes[i][k].total) {
              item.rowspan = cdimlength - k;
            }

            item.rowstart = i == 0;
            item.rowend = false;

            headeritem.push(item);
          }
        }
        if (headeritem.length > 0) {
          headeritem[headeritem.length - 1].rowend = true;
        }
      }
    }

    const idx = headeritem.length;
    if (this.reportData.colCount > 0 && msrlength > 1) {
      const acnt = this.getActualColCount();
      let m = 0;
      for (var k = 0; k < this.reportData.colCount; k++) {
        for (var i = 0; i < msrlength; i++) {
          m++;
          const item: Cell = this.emptyCell();
          item.content = this.getMeasureContent(this.reportDefine.measures[i].label, i);
          item.colspan = 1;
          item.rowspan = 1;
          item.rowstart = m == 1;
          item.rowend = m == acnt;
          headeritem.push(item);
        }
      }
    } else if (this.reportData.colCount == 0) {
      for (var i = 0; i < msrlength; i++) {
        const item: Cell = this.emptyCell();
        item.content = this.getMeasureContent(this.reportDefine.measures[i].label, i);
        item.colspan = 1;
        item.rowspan = 1;
        item.rowstart = i == 0;
        item.rowend = i == msrlength - 1;
        headeritem.push(item);
      }
    }
    return this.item2table(headeritem, idx, "top");
  }

  get left() {
    if (!this.reportData.dataValues ||
      this.reportData.dataValues.length == 0 ||
      this.reportData.rowCount == 0) {
      return { rows: [] };
    }

    const leftheaderitem = [];
    for (let k = 0; k < this.reportData.rowCount; k++) {
      const klen = this.reportData.rowDimNodes[k].length;
      for (let i = 0; i < klen; i++) {
        if (!this.reportData.rowDimNodes[k][i]) {
          continue;
        }
        if (k == 0 ||
          !this.reportData.rowDimNodes[k - 1][i] ||
          this.reportData.rowDimNodes[k][i].value != this.reportData.rowDimNodes[k - 1][i].value ||
          (this.reportData.rowDimNodes[k][i].value == this.reportData.rowDimNodes[k - 1][i].value && i == klen - 1)) {
          const item: Cell = this.emptyCell();
          item.content = this.getRowDimContent(k, i);
          item.rowspan = 1;
          let rspan = k + 1;
          if (i < klen - 1) {
            while (rspan < this.reportData.rowCount &&
            this.reportData.rowDimNodes[rspan] &&
            this.reportData.rowDimNodes[rspan][i] &&
            this.reportData.rowDimNodes[k][i].value == this.reportData.rowDimNodes[rspan][i].value) {
              rspan++;
              item.rowspan++;
            }
          }

          item.colspan = 1;
          if (this.reportData.rowDimNodes[k][i].total) {
            item.colspan = this.reportDefine.rowDims.length - this.reportData.rowDimNodes[k].length + 1;
          }

          item.rowstart = i == 0;
          item.rowend = i == this.reportData.rowDimNodes[k].length - 1;

          leftheaderitem.push(item);
        }
      }
    }
    const idx = leftheaderitem.length;
    return this.item2table(leftheaderitem, idx, "left");
  }

  get center() {
    if (!this.reportData.dataValues ||
      this.reportData.dataValues.length == 0 ||
      this.reportData.rowCount == 0) {
      return { rows: [] };
    }

    const msrlength = this.reportDefine.measures.length;
    const endCol = this.reportData.colCount > 0 ? this.reportData.colCount : 1;

    const centerbodyitem = [];
    let m = 0;
    const _colcnt = this.getActualColCount();
    for (let i = 0; i < this.reportData.rowCount; i++) {
      for (let k = 0; k < endCol; k++) {
        for (let j = 0; j < msrlength; j++) {
          m++;
          const item: Cell = this.emptyCell();
          item.content = this.getBodyContent(i, k, j);
          item.rowspan = 1;
          item.colspan = 1;
          item.rowstart = _colcnt == 1 || m % _colcnt == 1;
          item.rowend = _colcnt == 1 || m % _colcnt == 0;
          centerbodyitem.push(item);
        }
      }
    }
    const idx = centerbodyitem.length;
    return this.item2table(centerbodyitem, idx, "center");
  }

  private getBodyContent(row: number, col: number, msr: number) {
    // if (this.bodyFun)
    //	return eval(this.bodyFun + "(row, col, msr, this.rptDef);");

    let val = "0";
    if (this.reportData.colCount > 0) {
      if (this.reportData.rowColIndexes[row][col] >= 0) {
        val = "" + this.reportData.dataValues[this.reportData.rowColIndexes[row][col]][msr];
      }
    } else {
      if (this.reportData.rowColIndexes[row][0] >= 0) {
        val = "" + this.reportData.dataValues[this.reportData.rowColIndexes[row][0]][msr];
      }
    }

    return val;
  }

  private getRowDimContent(i: number, k: number) {
    // if (this.leftHeaderFun)
    //	return eval(this.leftHeaderFun + "(i, k, this.rptDef);");

    return this.reportData.rowDimNodes[i][k].label;
  }

  private getColDimContent(i: number, k: number) {
    // if (this.headerFun)
    //	return eval(this.headerFun + "(i, k, this.rptDef);");

    return this.reportData.colDimNodes[i][k].label;
  }

  private getMeasureContent(val: number, i: number) {
    return val + "";
  }

  private getActualColCount() {
    const cc: number = this.reportData.colCount == 0 ? 1 : this.reportData.colCount;
    return cc * this.reportDefine.measures.length;
  }

  private item2table(items: Array<Cell>, idx: number, position: string) {
    const table: Array<Row> = [];
    let f = true;
    for (let i = 0; i < idx; i++) {
      if (items[i].rowend && items[i].rowspan == 1) {
        f = false;
        break;
      }
    }

    let tr: Row = { cells: [] };
    let newRowFlag = true;
    for (let i = 0; i < items.length; i++) {
      const item: Cell = items[i];
      if (newRowFlag || item.rowstart) {
        newRowFlag = false;
        tr = { cells: [] };
        table.push(tr);
      }
      tr.cells.push(item);
      if (item.rowend) {
        if (f && position === "top") {
          item.rowspan = item.rowspan - 1;
        }
        newRowFlag = true;
      }
    }

    return {
      rows: table
    };
  }

  onLeftTopClick() {
    // alert('onLeftTopClick');
  }

  onTopClick(row: number, col: number) {
    // alert("onTopClick row=" + row + ", col=" + col);
  }

  onLeftClick(row: number, col: number) {
    // alert("onLeftClick row=" + row + ", col=" + col);
  }

  onCenterClick(row: number, col: number, value: string) {
    if (this.hideMeasureLink) {
      return;
    }
    if (value === "0") {
      return;
    }

    const keys = [];
    for (var i = 0; i < this.reportData.rowDimNodes[row].length; i++) {
      keys.push(this.reportData.rowDimNodes[row][i].value);
    }
    if (this.reportData.rowDimNodes[row].length < this.reportDefine.rowDims.length) {
      for (var i = 0; i < this.reportDefine.rowDims.length - this.reportData.rowDimNodes[row].length; i++) {
        keys.push(TOTAL_KEY);
      }
    }
    if (this.reportData.colDimNodes.length > 0) {
      for (var i = 0; i < this.reportData.colDimNodes[col].length; i++) {
        keys.push(this.reportData.colDimNodes[col][i].value);
      }
      if (this.reportData.colDimNodes[col].length < this.reportDefine.colDims.length) {
        for (var i = 0; i < this.reportDefine.colDims.length - this.reportData.colDimNodes[col].length; i++) {
          keys.push(TOTAL_KEY);
        }
      }
    }

    // alert("onCenterClick row=" + row + ", col=" + col + ", key=" + keys.join(","));
    const dims: Array<any> = [];
    for (let i = 0; i < this.reportDefine.rowDims.length; i++) {
      dims.push(this.reportDefine.rowDims[i]);
    }
    if (this.reportDefine.colDims) {
      for (let i = 0; i < this.reportDefine.colDims.length; i++) {
        dims.push(this.reportDefine.colDims[i]);
      }
    }

    const conds: { [key: string]: any } = {};
    const titles: Array<string> = [];
    let isDate = false;
    for (let idx = 0; idx < dims.length; idx++) {
      const key = keys[idx];
      if (key === TOTAL_KEY) {
        continue;
      }
      const dim = dims[idx];
      const cond: any = {
        name: dim.name
      };
      if (key === "") {
        cond.operator = "NULL";
        conds[dim.name] = cond;
        titles.push(dim.label + "为空");
        continue;
      }

      titles.push(dim.label + "=" + key);

      if (dim.dateUnit) {
        isDate = true;
        cond.operator = "BETWEEN";
        if (dim.dateUnit === "YEAR") {
          cond.value1 = key + "-01-01";
          cond.value2 = key + "-12-31";
        } else if (dim.dateUnit === "MONTH") {
          let y = 0;
          let m = parseInt(key);
          if (key.length === 7) {
            const ym = key.split("-");
            y = parseInt(ym[0]);
            m = parseInt(ym[1]);
          } else {
            for (let pidx = idx - 1; idx >= 0; pidx--) {
              if (dims[pidx].name === dim.name && dims[pidx].dateUnit === "YEAR") {
                y = parseInt(keys[pidx]);
                break;
              }
            }
          }
          cond.value1 = y + "-" + (m < 10 ? "0" + m : m) + "-01";
          const d = new Date(y, m, 0).getDate();
          cond.value2 = y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
        }
      } else {
        if (dim.name.indexOf("category") === 0 && !dim.self) {
          cond.operator = "BELONG_TO";
        } else {
          cond.operator = "EQUAL";
        }
        cond.value1 = key;
      }

      if (conds[dim.name] && isDate) {
        const ocond = conds[dim.name];
        if (ocond.operator === "NULL") {
          conds[dim.name] = ocond;
        } else {
          if (ocond.value1 > cond.value1) {
            cond.value1 = ocond.value1;
          }
          if (ocond.value2 < cond.value2) {
            cond.value2 = ocond.value2;
          }
          conds[dim.name] = cond;
        }
      } else {
        conds[dim.name] = cond;
      }
    }

    this.condition = JSON.parse(JSON.stringify(this.reportDefine.condition ? this.reportDefine.condition : { items: [], relation: "" }));
    if (!this.condition) {
      this.condition = { items: [], relation: "" };
    }
    if (!this.condition.items) {
      this.condition.items = [];
    }

    for (const idx in conds) {
      this.condition.items.push(conds[idx]);
    }

    this.showReportListWin = true;
    this.reportWinTitle = "专利列表: " + titles.join("; ");
    this.loadPatentList();
  }

  @Provide()
  get projectId() {
    if (this.$route.name === "MonitorIndex") {
      return MONITOR_PROJECT_ID;
    }

    const pInfo: any = this.$store.state.project.info || {};
    return this.$route.query.id || pInfo.id || 0;
  }

  private loadPatentList() {
    const condObject = {
      condition: JSON.stringify(this.condition),
      page: this.pageIndex - 1,
      pageSize: this.pageSize,
      orderBy: ""
    };
    const projectId = this.projectId;
    this.$http.post<{ count: number, data: Array<any> }>({
      url: API_BIS_PATENT_LIST,
      path: { projectId: projectId }
    }, condObject).then(({ count, data }) => {
      this.recordCount = count;
      this.patentData = data;
    }).catch(() => {
    });
  }

  @Watch("pageSize")
  onPagePropertyChange() {
    if (this.pageIndex === 1) {
      this.loadPatentList();
    } else {
      this.pageIndex = 1;
    }
  }

  @Watch("pageIndex")
  onPageIndexChange() {
    this.loadPatentList();
  }

  exportExcel() {
    const xlsxParam = { raw: true };
    const wb = XLSX.utils.table_to_book(this.$refs.tablebody, xlsxParam);
    const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
    try {
      FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), this.reportTitle + ".xlsx");
    } catch (e) {
      if (typeof console !== "undefined") {
        console.log(e, wbout);
      }
    }
    return wbout;
  }
}
